export const campaignBoxTypes = {
  STRUCTURE: 'structure',
  ETIQUETTES: 'etiquettes',
  SUMMARY: 'SUMMARY',
};
